// @ts-nocheck
import { SET_PAGINATION, CLEAR_PAGINATION } from '../types';

const initialState = {};

const pagination = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case SET_PAGINATION: {
            return {
                ...state,
                [payload.paginationKey]: {
                    ...state[payload.paginationKey],
                    ...payload.paginationProps,
                },
            };
        }
        case CLEAR_PAGINATION: {
            const { [payload]: deletedPagination, ...newState } = state;

            return newState;
        }
        default:
            return state;
    }
};

export default pagination;
